export default __webpack_public_path__ + "static/media/Logo.b795af2d.svg";